import React from "react";
import { Button } from "~/widgets/Button/Button";
import styles from "~/widgets/EmptyTableState/EmptyTableState.module.scss";

export interface EmptyTableStateProps {
  tableName: string;
  onCreateCharacter: () => void;
}

/**
 * EmptyTableState Component
 *
 * Displayed when a table has no characters.
 * Prompts the user to create a new character.
 */
const EmptyTableState: React.FC<EmptyTableStateProps> = ({
  tableName,
  onCreateCharacter,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>No Characters in {tableName}</h2>
        <p className={styles.message}>
          This table doesn't have any characters yet.
        </p>
        <Button onClick={onCreateCharacter} variant="primary">
          Create New Character
        </Button>
      </div>
    </div>
  );
};

export default EmptyTableState;
